// store
import storage from '../../storage/localStorage';

export default storage('/gohalo/dashboard/portfolio/update/date');
